export { default } from './Footer'